import { z } from 'zod';

export const FileDataSetConfig = z.object({
  dataSetType: z.literal('File'),
  fileName: z.string(),
});

export type FileDataSetConfig = z.infer<typeof FileDataSetConfig>;
